export { default as GithubIcon } from '/public/images/icons/integrations/github.svg';
export { default as GoogleIcon } from '/public/images/icons/integrations/google.svg';
export { default as HubDBTinyIcon } from '/public/images/icons/integrations/hubdb-tiny.svg';
export { default as HubDBIcon } from '/public/images/icons/integrations/hubdb.svg';
export { default as HubSpotTinyIcon } from '/public/images/icons/integrations/hubspot-tiny.svg';
export { default as HubSpotIcon } from '/public/images/icons/integrations/hubspot.svg';
